import { useState } from "react";

export const instructorDetails = {
	name: "Soham Wani",
	src: "/soham.jpeg",
	tagline: "Web Developer, Product Designer",
};

export const courseHeading =
	"Build Responsive Real-World Websites with HTML and CSS";

export const courseSubtitle =
	"Learn modern HTML, CSS, and web design by building a real professional website from scratch";

export function CourseWhatLearn() {
	return (
		<div className="what-you-learn">
			<h2>What you'll learn</h2>
			<div className="learn-grid">
				<div className="learn-item">
					Become a modern and confident HTML and CSS developer, no prior
					knowledge needed!
				</div>
				<div className="learn-item">
					Design and build a stunning real-world project for your portfolio from
					scratch
				</div>
				<div className="learn-item">Modern, semantic and accessible HTML5</div>
				<div className="learn-item">
					Modern CSS (previous CSS3), including flexbox and CSS Grid for layout
				</div>
				<div className="learn-item">
					Important CSS concepts such as the box model, positioning schemes,
					inheritance, solving selector conflicts, etc.
				</div>
				<div className="learn-item">
					A web design framework with easy-to-use rules and guidelines to design
					eye-catching websites
				</div>
				<div className="learn-item">
					How to plan, sketch, design, build, test, and optimize a professional
					website
				</div>
				<div className="learn-item">
					How to use common components and layout patterns for professional
					website design and development
				</div>
				<div className="learn-item">
					Developer skills such as reading documentation, debugging, and using
					professional tools
				</div>
				<div className="learn-item">
					How to find and use free design assets such as images, fonts, and
					icons
				</div>
			</div>
		</div>
	);
}

export function CourseIncludes() {
	return (
		<div className="includes-section">
			<h2>This course includes:</h2>
			<p style={{ fontSize: "1.4rem", marginBottom: "1.6rem" }}>
				This course includes our well designed ciricullum, resources and
				challenges curated to cater your needs so you can practice your skills
				as you learn.
			</p>
			<div className="includes-grid">
				<div className="includes-item">
					<span>📹</span> One to One teaching sessions
				</div>
				<div className="includes-item">
					<span>💻</span> Coding exercises
				</div>
				<div className="includes-item">
					<span>📄</span> Assignments
				</div>
				<div className="includes-item">
					<span>💾</span> Downloadable resources
				</div>
				<div className="includes-item">
					<span>🏆</span> Certificate of completion
				</div>
			</div>
		</div>
	);
}

export function CourseReq() {
	return (
		<div className="requirements-section">
			<h2>Requirements</h2>
			<ul>
				<li>
					No coding experience is necessary to take this course! I take you from
					beginner to expert!
				</li>
				<li>
					Any computer and OS will work — Windows, macOS or Linux. We will set
					up your text editor the course.
				</li>
				<li>
					You don’t need to buy any software — we will use the best free code
					editor in the world{" "}
				</li>
			</ul>
		</div>
	);
}

export const courseCiricullum = [
	{
		heading: "Introduction to Web Development",
		contents: [
			"A High-Level Overview of Web Development",
			"Setting Up Our Code Editor",
			"Your Very First Webpage",
			"Downloading Course Material",
		],
	},
	{
		heading: "HTML Fundamentals",
		contents: [
			"Introduction to HTML",
			"HTML Document Structure",
			"Text Elements",
			"Lists and Text Formatting",
			"Images and Attributes",
			"Hyperlinks",
			"Structuring the Page",
			"Semantic HTML: Why It Matters",
		],
	},
	{
		heading: "CSS Basics",
		contents: [
			"Introduction to CSS",
			"Inline, Internal and External CSS",
			"Styling Text",
			"Class and ID Selectors",
			"Combining Selectors",
			"Working With Colors",
			"Styling Hyperlinks",
			"Pseudo-classes",
			"Pseudo-elements",
			"CSS Variables",
			"Using Chrome DevTools",
		],
	},
	{
		heading: "Core CSS Theory",
		contents: [
			"CSS Theory #1: Conflicts Between Selectors (Specificity)",
			"CSS Theory #2: Inheritance and the Universal Selector",
			"CSS Theory #3: The CSS Box Model",
			"Using Margins and Padding",
			"Adding Dimensions",
			"Centering Elements",
			"CSS Theory #4: Types of Boxes",
			"CSS Theory #5: Positioning (Relative, Absolute, Fixed)",
		],
	},
	{
		heading: "Developer Skills",
		contents: [
			"Googling and Reading Documentation",
			"Debugging and Asking Questions",
		],
	},
	{
		heading: "CSS Layout Systems",
		contents: [
			"The Three Ways of Building Layouts",
			"Using Floats and Their Drawbacks",
			"box-sizing: border-box",
		],
	},
	{
		heading: "Flexbox",
		contents: [
			"Introduction to Flexbox",
			"Flexbox Overview",
			"Spacing and Aligning Flex Items",
			"The flex Property",
			"Adding Flexbox to Our Project",
			"Building a Simple Flexbox Layout",
		],
	},
	{
		heading: "CSS Grid",
		contents: [
			"Introduction to CSS Grid",
			"CSS Grid Overview",
			"Sizing Grid Columns and Rows",
			"Placing and Spanning Grid Items",
			"Aligning Grid Items and Tracks",
			"Building a Simple CSS Grid Layout",
		],
	},
	{
		heading: "Web Design Fundamentals",
		contents: [
			"Overview of Web Design and Website Personalities",
			"Typography: Rules and Implementation",
			"Colors: Rules and Implementation",
			"Images and Illustrations",
			"Icons and Implementation",
			"Shadows and Implementation",
			"Border Radius and Implementation",
			"Whitespace",
			"Visual Hierarchy and Implementation",
			"User Experience (UX)",
			"Website Personalities Framework",
			"Steal Like an Artist",
		],
	},
	{
		heading: "Components and Layout Patterns",
		contents: [
			"Elements and Components",
			"Building an Accordion Component",
			"Building a Carousel Component",
			"Building a Table Component",
			"Layout Patterns",
			"Building a Web Application Layout",
		],
	},
	{
		heading: "From Idea to Website",
		contents: ["The 7 Steps to a Great Website"],
	},
	{
		heading: "Final Project: Yash Enterprises",
		contents: [
			"Defining and Planning the Project",
			"Sketching Initial Layout Ideas",
			"First Design and Development Steps",
			"Responsive Design Principles",
			"How rem and max-width Work",
			"Building the Hero Section",
			"Building the Header",
			"Building the Navigation",
			"Setting Up a Reusable Grid",
			"Building the Features Section",
			"Building the Top Companies Section",
			"Building the Wishlist Section",
			"Building the Cart Section",
			"Building the Product Card",
			"Building the Single Product Page",
			"Implementing Subtle Hover Animations",
			"Implementing Smooth Scrolling",
			"Browser Support and Safari Flexbox Gap Fix",
			"Testing Performance with Lighthouse",
			"Adding Favicon and Meta Description",
			"Image Optimization",
			"Deployment to Netlify",
		],
	},
];

export function CourseDesc() {
	const [showFullDescription, setShowFullDescription] = useState(false);

	const toggleDescription = () => {
		setShowFullDescription(!showFullDescription);
	};
	return (
		<div className="description-section">
			<h2>Description</h2>
			<div className="description-content">
				<p>
					Open a new browser tab, type in www.yashenterprises.netlify.app, and
					take a look around. I will wait here...
				</p>
				<p>
					Amazing, right? What if you knew exactly how to design and build a
					website like that, completely from scratch? How amazing would that be?
				</p>
				<p>
					Well, I'm here to teach you HTML, CSS, and web design, all by building
					the stunning website that you just saw, step-by-step.
				</p>
				<p>
					So, after finishing this course, you will know exactly how to build a
					beautiful, professional, and ready-to-launch website just like
					YashEnterprises, by following a 7-step process. And it will even look
					great on any computer
				</p>
				<p>
					But what if you want to build a completely different website? Well, no
					problem! I designed the course curriculum with exactly this goal: to
					enable you to design and build any website that you can think of, not
					just copy the course project.
				</p>

				{showFullDescription && (
					<>
						<p>
							So, in order to become a confident and independent developer,
							capable of building your own websites in the future, you will
							learn:
						</p>
						<ul>
							<li>
								The fundamentals of modern and semantic HTML, CSS, and building
								layouts in a small separate project, which will prepare you for
								the main course project (www.yashenterprises.netlify.app). This
								includes modern flexbox and CSS Grid!
							</li>
							<li>
								How to design beautiful websites, by learning a web design
								framework I created just for this course. It consists of
								easy-to-use guidelines for design aspects like typography,
								colors, images, spacing, and more (this is like a small
								standalone course!).
							</li>
							<li>
								How to use well-established website components and layout
								patterns in order to come up with professional-looking designs
							</li>
							<li>
								How to use the 7 steps of building a professional website in
								practice: planning, sketching, designing, building, testing,
								optimizing, and launching
							</li>
							<li>
								How to find and use free design assets such as images, fonts,
								and icons
							</li>
							<li>
								Important developer skills such as reading documentation, fixing
								code errors on your own, and using professional web development
								tools
							</li>
						</ul>

						<p>
							Does this sound like fun? Then join me and 200,000+ other
							developers and start building websites today!
						</p>
						<p>
							Or are you not sold yet and need to know more? No problem, just
							keep reading...
						</p>

						<h3>[01] Why should you learn HTML and CSS in the first place?</h3>
						<p>
							Building websites allows you to do fun and creative work, from
							anywhere in the world, and it even pays well. Web development is
							one of the most future-proof and highest-paying industries in the
							world. And HTML and CSS is the entry point to this world!
						</p>
						<p>
							But you already know all this, that's why you want to learn HTML
							and CSS too. Well, you came to the right place!
						</p>
						<p>
							This is the best and most complete course for starting your web
							development journey that you will find. It's an all-in-one package
							that takes you from knowing nothing about HTML and CSS, to
							building beautiful websites using tools and technologies that
							professional web developers use every single day.
						</p>

						<h3>[02] Why is this course so unique?</h3>
						<p>
							<strong>Reason #1: The course is completely project-based</strong>
						</p>
						<p>
							Simple demos are boring, and therefore you're gonna learn
							everything by building actual projects! In the final project
							(www.yashenterprises.netlify.app), together we hand-code a
							beautiful and responsive landing page and a few additional pages
							for a original wholesale business.
						</p>

						<p>
							<strong>Reason #2: You will not just learn how to code</strong>
						</p>
						<p>
							Coding is great, but it's not everything! That's why we will go
							through the entire 7-step process of building and launching our
							website project.
						</p>
						<p>
							So the huge Yash enterprises project will teach you real-world
							skills to build real-world HTML and CSS websites: how to plan
							projects and page layouts, how to implement designs using HTML and
							CSS techniques, how to write clean and organized code, how to
							optimize websites for good speed performance, and many more.
						</p>
						<p>
							On top of that, this course has a huge focus on beautiful design.
							In fact, this might be the only course on the market that focuses
							on both coding and designing, together.
						</p>

						<p>
							<strong>Reason #3: I'm the right teacher for you</strong>
						</p>
						<p>
							With the right guidance and a well-structured curriculum, building
							websites can be quite easy and fun to learn. With a bunch of
							random tutorials and YouTube videos? Not so much. And that's where
							I come in.
						</p>
						<p>
							My name is Soham, I'm an experienced web developer and designer,
							and a Student just like you who has started learning web
							development and design just a bit early in life. I have learned
							various web technologies but honestly, in the hard way I didn't
							had much guidance myself but I have been doing web development
							since around 6 years, I have worked in the IT industry for a few
							months as a tech lead, I have freelanced some products and
							designed many products and thus have figured out the best way to
							approach this beautiful journey, also I as a fellow student and a
							person of your age I know exactly what the industry asks for today
							from our generation of students and have figured out how our
							generation can acquire that skills with ease and utmost
							creativity.
						</p>
						<p>
							Using that Experience, I recently built this course from scratch
							and designed the ideal course curriculum for every type of
							student. It's a unique blend of projects, deep explanations,
							theory lectures, and challenges. I'm sure you're gonna love it!
						</p>

						<h3>[03] Why is this course so long?</h3>
						<p>
							<strong>Reason #1:</strong> I take time to explain every single
							concept that I teach, so that you actually learn, and not just
							copy code from the screen (this is a course, not a tutorial)
						</p>
						<p>
							<strong>Reason #2:</strong> I go into topics that other HTML and
							CSS courses shy away from: professional web design, component and
							layout patterns, some CSS theory, website planning in theory and
							practice, and developer skills. I believe you need all of this to
							be successful!
						</p>
						<p>
							<strong>Reason #3:</strong> There is a lot of repetition, so that
							you actually assimilate and practice what you learn. Practice is
							the single most important ingredient to learning, and therefore I
							provide plenty of opportunities for you to sharpen your skills
						</p>

						<h3>[04] This course is for you if...</h3>
						<ul>
							<li>
								... you are a complete beginner with no idea of how to build a
								website.
							</li>
							<li>
								... you already know a bit of HTML and CSS from some tutorials
								or videos, but struggle to put together a good-looking, complete
								website.
							</li>
							<li>
								... you are a designer and want to expand your skills into HTML
								and CSS, because all your designer friends are learning how to
								code (they are smart!).
							</li>
						</ul>
						<p>
							Basically, if you are an HTML and CSS master, and build the most
							beautiful websites in the world, then DON'T take the course.
							Everyone else: you should take the course, today.
						</p>
					</>
				)}
			</div>
			<button className="show-more-btn" onClick={toggleDescription}>
				{showFullDescription ? "Show less" : "Show more"}
			</button>
		</div>
	);
}

export function CourseFor() {
	return (
		<div className="for-course-section">
			<h2>Who this course is for:</h2>
			<ul>
				<li>
					Complete beginners who want to learn how to build a professional,
					beautiful and responsive website{" "}
				</li>
				<li>
					Students with some knowledge about HTML and CSS, but who struggle to
					put together a great website
				</li>
				<li>
					Designers who want to expand their skill set into HTML5 and CSS3{" "}
				</li>
			</ul>
		</div>
	);
}
